import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { Form, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useSelector } from "react-redux";
import i18n from '../../i18n';
import EDMHeader from "./EDMHeaderV2";
import EDMFooter from "./EDMFooter";
import EDMBanner from "./EDMBanner";


const useStyles = makeStyles((theme) => ({
    edmStyle: {
        fontFamily: "Montserrat, Noto Sans TC, Noto Sans SC, Arial, Helvetica, sans-serif !important"
    },
    header: {
        width: "100%",
        textAlign: "center",
        color: "white",
    },
    bannerContainer: {
        height: "150px",
        position: "relative"
    },
    bannerVerticalCenter: {
        margin: "0",
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        textAlign: "center",
        width: "100%",
        fontSize: "30px"
    },
    body: {
        marginBottom: "50px"
    },
    bodyContent: {
        padding: "20px",
        maxWidth: "600px",
        margin: "auto"
    },
    form: {
        maxWidth: "400px",
        margin: "auto",
        padding: "10px"
    },
    title: {
        backgroundColor: "#f1f1f1",
        verticalAlign: "middle",
    },
    footer: {
        width: "100%",
        backgroundColor: "#243d77",
        textAlign: "center",
        color: "white",
        position: "fixed",
        bottom: "0",
        padding: "10px 0"
    },
    mandatoryLabel: {
        color: "#f38660"
    },
    submitButton: {
        width: "200px",
        margin: "auto",
        backgroundImage: "linear-gradient(#f7925a, #f15a23)",
        border: "none"
    },
    captchaStyle: {
        width: "100px",
        height: "40px"
    },
    errorMsg: {
        color: "#ff0000",
        fontSize: "12px"
    },
    shareLinkStyle: {
        border: "1px solid #a1a1a1",
        borderRadius: "10px",
        padding: "10px",
        color: "#f15a23"
    }
}));

function EDMConfirm() {
    const { t } = useTranslation();
    const classes = useStyles();
    const refNo = useSelector((state) => state.refNo);

    function changeLang(e) {
        i18n.changeLanguage(e.target.value);
    }

    function onCopyClick() {
        navigator.clipboard.writeText(`${process.env.REACT_APP_SHARE_TO_FRIENDS_URL}`);
    }

    return (
        <div className={classes.edmStyle}>
            <EDMHeader props={{}}/>
            <EDMBanner titleKey="EDMV2.ThankYou"/>
        

            <div className={classes.body}>
                <div className={classes.bodyContent}>
                    <div style={{width: "100%"}}>
                        {/* <div className="mt-3" style={{textAlign: "center"}}><p>{t("EDM.ReferenceNumber")}: {refNo}</p></div>
                        <div className="mt-3" style={{textAlign: "center"}}><p>{t("EDM.WeHaveReceivedYourRequest")}</p></div> */}
                        <div className="mt-3" >
                            <p style={{ fontSize: '16px' }} dangerouslySetInnerHTML={{ __html: t("EDMV2.ThankYouMsg")}} />
                        </div>
                                {/* <a style={{
                                    color: 'black'
                                }} href={t("EDMV2.ResearchReportURL")} target="_blank">{t("EDMV2.ResearchReports")}</a>                         */}
                        {/* <div className="mt-3" style={{textAlign: "center"}}><p><strong>{t("EDM.ShareToFriends")}</strong></p></div>
                        <center><Form.Label className={classes.shareLinkStyle}>{process.env.REACT_APP_SHARE_TO_FRIENDS_URL}</Form.Label></center>
                        
                        <div className="mt-3" style={{margin: "auto", textAlign: "center"}}>
                            <Button as="input" type="submit" value={t("EDM.CopyLink")} className={classes.submitButton} onClick={onCopyClick} />
                        </div> */}
                    </div>
                </div>
            </div>

            <div className={classes.footer}>
                <EDMFooter/>
            </div>
        </div>
    )
}

export default EDMConfirm;